<template>
  <div class="root" style="background-color: '#f8f9ff' ">
    <div
      class="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom box-shadow"
    >
      <div class="container">
        <div class="row">
          <div class="col-9 p-0">
            <img
              src="/images/shop.png"
              style="max-height: 50px"
              v-on:click="goToProductList()"
            />&nbsp;&nbsp;
            <b style="font-size: 1.2em" v-on:click="goToProductList()">{{
              this.$store.state.shop.shop_name
            }}</b>
          </div>
          <div class="col-3 align-self-center" style="text-align: right">
            <button
              class="btn btn-icon-white btn-sm px-4"
              style="width: 140px"
              v-on:click="share()"
            >
              <img src="../assets/share-purple.png" style="width: 20px" />
              &nbsp;
              <span
                style="color: #4100c3; text-decoration: underline; font-size: 1.1em"
                >Compartir</span
              >
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goToProductList() {
      this.$router.push({
        name: `ProductList`,
      });
    },
    share() {
      if (navigator.share) {
        window.amplitude.getInstance().logEvent("Shop Shared", {
          timestamp: new Date(),
          shop: this.$route.params.id,
        });
        navigator
          .share({
            title: this.$store.state.shop.shop_name,
            text: "Hola! Revisa mi tienda aquí",
            url: window.location.pathname,
          })
          .then(() => console.log("Successful share"))
          .catch((error) => console.log("Error sharing", error));
      }
    },
  },
};
</script>

<style scoped>
.container-sm .container-md {
  margin: 15px 0px;
}
</style>
